module.exports = __webpack_public_path__ + "static/img/banner-wenzi.dd1f57c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/2020/app/banner-wenzi.png
// module id = skrH
// module chunks = 69